import React , { useEffect, useState, useCallback } from "react";
import AdminData from '../../Data/Admin/Listdata.json';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faPenToSquare, faTrashCan} from '@fortawesome/free-solid-svg-icons';
import { Link, useNavigate } from "react-router-dom";
import { getExhibitorList,deleteExhibitor } from '../../Service';
import Swal from "sweetalert2";
import ReactPaginate from 'react-paginate';

export default function AdminList(){
    const navigation = useNavigate();
    const [exhibitorList, setExhibitorList] = useState([]);
    //const [deleteList, deleteExhibitorList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [perPage, setPerPage] = useState(10);
    const [curPage, setCurPage] = useState(1);

    /** ------------------------ Pagination States -------------- */
    const data = exhibitorList;
    const [currentItems, setCurrentItems] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [itemOffset, setItemOffset] = useState(0);
    const [itemsPerPage, setitemsPerPage] = useState(0);
    /** ------------------------ Pagination States -------------- */

    useEffect(() => {
        let params = { 'perPage': perPage, 'curPage': curPage };
        getExhibitorList(params).then(res => handleResponse(res))
      }, [curPage]);

    const handleResponse = (response) => {
        if(response.data.code==200){  //IF Request is Success
            setExhibitorList(response.data.data.user.items);
            setitemsPerPage(10); //SET LIST OF RECORDS PER PAGE.
        } else { //IF Token Expired......
            const errors = {};
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: response.data.message,
            })
        } 
    }

    /** ------------------------ Pagination Start Here ------------------------  */
    useEffect(() => {
        const endOffset = itemOffset + itemsPerPage;
        setCurrentItems(data.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(data.length / itemsPerPage));
      }, [itemOffset, itemsPerPage]);

      
      const handlePageClick = useCallback ((event) => {
        const newOffset = (event.selected * itemsPerPage) % data.length;
        setItemOffset(newOffset);
        console.log(newOffset);
      });
  /** ------------------------ Pagination Ends Here ------------------------  */
 
    const deleteUser = (data)=> {
        
        Swal.fire({
            title: 'Are you sure?',
            text: "Do you want delete this Exhibitor?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
          }).then((result) => {
            if (result.isConfirmed) {
                deleteExhibitor(data.id).then(res => handleDeleteResponse(res, data.id))
            }
          })
    }

    const handleDeleteResponse = (response, exhibitor_id) => {
        if(response.data.code==200){  //IF Request is Success
            console.log(exhibitor_id);
            let allEventData = currentItems;
            console.log(allEventData);
            let filteredArray =  allEventData.filter(item => item.id !== exhibitor_id);
            console.log(filteredArray);
            setCurrentItems(filteredArray);
              Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Exihibitor Deleted Successfully',
                showConfirmButton: false,
                timer: 1500
              })
        } else { //IF Token Expired......
            const errors = {};
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: response.data.message,
            })
        } 
    }
    console.log('data'+data);
    console.log('Current Items'+currentItems);
    //console.log('Check Delete Data', deleteList);
    return(
        <section className="admin-section">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="card admin-table"> 
                            <div className="card-header">
                                <h1>Exhibitor Account List</h1>    
                            </div>
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Address</th>
                                                <th>Email</th>
                                                <th>Gallery Name</th>
                                                <th> Website</th>
                                                <th>Status</th>
                                                <th>Edit/Delete</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                currentItems.map((data, index)  => (
                                                    <tr key={data.id}>
                                                        <td>{data.primary_contact_full_name}</td>
                                                        <td>{data.address1}</td>
                                                        <td>{data.email}</td>
                                                        <td>{data.name}</td>
                                                        <td>{data.website}</td>
                                                        <td>{data.status}</td>
                                                        <td className="admin-editdelete"><Link to={"/exhibitor_edit/"+data.id}><FontAwesomeIcon icon={faPenToSquare} /></Link> / <a href="javascript:void(0);" onClick={() => deleteUser(data)}><FontAwesomeIcon icon={faTrashCan} /></a> </td> 
                                                    </tr> 
                                                ))
                                            }
                                        </tbody>
                                    </table> 
                                </div>
                            </div>
                            <div className="card-footer">
                            <ReactPaginate
                                breakLabel="..."
                                nextLabel="Next"
                                onPageChange={handlePageClick}
                                pageRangeDisplayed={5}
                                pageCount={pageCount}
                                previousLabel="Previous"
                                renderOnZeroPageCount={null}
                                className="admin-paginate"
                            />
            </div>
                        </div>
                    </div>
                </div>
            </div>  
        </section>
    )
}
